const messages = {
  "welcome": "Welkom bij BRIDGESTONE PLUS – Bridgestone's portaal met toegevoegde waarde.",
  "step1": {
    "title": "Nieuw hier?",
    "description": "Is dit de eerste keer dat u het BRIDGESTONE <span class='text-danger'>PLUS</span> portaal bezoekt?<br /><br />Registreer u dan nu!",
    "actionBtn": "WORD NU LID"
  },
  "step2": {
    "title": "BAND<span class='text-danger'>CLUB</span>-dealer",
    "description": "Heeft u al toegangsgegevens voor de voormalige Bridgestone TYRE<span class='text-danger'>CLUB</span>?<br /><br />Stel dan hier uw nieuwe wachtwoord in voor het e-mailadres waarmee u de TYRE< span class='text-danger'>CLUB</span>.",
    "actionBtn": "STEL NIEUW WACHTWOORD IN"
  },
  "step3": {
    "title": "Welkom bij BRIDGESTONE <span class='text-danger'>PLUS</span>",
    "description": "Log in met uw e-mailadres en wachtwoord.<br/><br/><br/><b>Bent u nieuw hier?</b><br/><br/>Maak dan eerst uw nieuwe gebruikersaccount aan met de functie AANMELDEN.<br/><br/>U wordt daarna automatisch ingelogd.",
    "actionBtn": "AANMELDEN"
  },
  "info": "Heeft u hulp nodig? Neem dan contact met ons op: <a href=\"mailto:{email}\">{email}</a>"
};

export default {
  messages,
};
